import { gql } from "urql";

export const USER_UPGRADE_ACCOUNT = gql`
  mutation userUpgradeAccount {
    userUpgradeAccount {
      data
    }
  }
`;

export const USER_INFO_SUBSCRIPTION = gql`
  query UserInfoSubscription {
    userInfo {
      id
      hasAttemptedGemCamSetup
      additionalInfo {
        isGemhubPreviewUser
        isExistingUser
        skipQuestionnaire
        canRatingApp
        requireOnboardingSurvey
      }
      organization {
        address
        gemStudioCredits
        additionalInfo {
          GemCamTradeInFlagStatus
          genAiEnabled
          genAiModelImageEnabled
          genAiLifestyleImageEnabled
          genAiChangeMetalMaterialEnabled
        }
        id
        name
        operatorType
        primaryUseCase
        jewelryType
      }
    }
  }
`;

export const USER_ONBOARDING_SURVEY_INFO = gql`
  query UserOnboardingSurveyInfo {
    userInfo {
      additionalInfo {
        requireOnboardingSurvey
      }
      organization {
        id
        operatorType
        primaryUseCase
        jewelryType
      }
    }
  }
`;

export const ORGANIZATION_UPDATE_ONBOARDING_SURVEY = gql`
  mutation organizationUpdate($organizationId: Int!, $input: OrganizationInput!) {
    organizationUpdate(organizationId: $organizationId, input: $input) {
      id
      operatorType
      primaryUseCase
      jewelryType
    }
  }
`;

export const USER_FEATURES = gql`
  query UserFeatures {
    userFeatures {
      data {
        name
        type
        limitJson {
          quota
          unlimited
          unit
        }
        resetInterval
        usageJson {
          usage
          unit
          resetAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const AI_LIFESTYLE_IMAGE_TEMPLATES = gql`
  query AiLifestyleImageTemplates(
    $page: Int = 1
    $pageSize: Int = 9999
    $kind: AiLifestyleImageKind = all
  ) {
    aiLifestyleImageTemplates(page: $page, pageSize: $pageSize, kind: $kind) {
      data {
        id
        file {
          original
          small
        }
        previewFile {
          small
        }
        type
        sort
        createdAt
        updatedAt
      }
      totalRecords
      totalPages
    }
  }
`;

export const AI_SKIN_TONE_LIST = gql`
  query AiSkinToneList {
    aiSkinToneList {
      data {
        description
        key
        name
        sort
        file {
          small
          transcoded
          preview
          original
          medium
        }
      }
    }
  }
`;

export const AI_METAL_COLOR_LIST = gql`
  query AiMetalColorList {
    aiMetalColorList {
      data {
        description
        file {
          original
          small
        }
        key
        name
        sort
      }
    }
  }
`;

// export const AI_MODEL_IMAGE = gql`
//   mutation AIModelImage($guid: String!, $mediaId: Int, $jewelryType: String) {
//     aiModelImage(guid: $guid, mediaId: $mediaId, jewelryType: $jewelryType) {
//       data
//     }
//   }
// `;

// export const AI_LIFESTYLE_IMAGE = gql`
//   mutation AILifestyleImage($guid: String!, $mediaId: Int, $backgroundFileUrl: String) {
//     aiLifestyleImage(guid: $guid, mediaId: $mediaId, backgroundFileUrl: $backgroundFileUrl) {
//       data
//     }
//   }
// `;

// export const AI_CHANGE_METAL_MATERIAL = gql`
//   mutation AIChangeMetalMeterial(
//     $guid: String!
//     $mediaId: Int
//     $targetMetalMaterial: MetalMaterial!
//   ) {
//     aiChangeMetalMaterial(
//       guid: $guid
//       mediaId: $mediaId
//       targetMetalMaterial: $targetMetalMaterial
//     ) {
//       data
//     }
//   }
// `;

export const AI_MODEL_IMAGE = gql`
  mutation AIModelImage(
    $mediaId: Int
    $jewelryType: String
    $gender: Gender
    $skinToneKey: String
    $jewelrySize: AIModelImageJewelrySizeInput
  ) {
    aiModelImageAsync(
      mediaId: $mediaId
      jewelryType: $jewelryType
      gender: $gender
      skinToneKey: $skinToneKey
      jewelrySize: $jewelrySize
    ) {
      id
      taskId
      type
      status
    }
  }
`;

export const AI_LIFESTYLE_IMAGE = gql`
  mutation AILifestyleImage($mediaId: Int, $templateId: Int) {
    aiLifestyleImageAsync(mediaId: $mediaId, templateId: $templateId) {
      id
      taskId
      type
      status
    }
  }
`;

export const AI_CHANGE_METAL_MATERIAL = gql`
  mutation AIChangeMetalMeterial($mediaId: Int, $targetMetalColorKey: String) {
    aiChangeMetalMaterialAsync(mediaId: $mediaId, targetMetalColorKey: $targetMetalColorKey) {
      id
      taskId
      type
      status
    }
  }
`;

export const USER_CREATE_GENERATIVE_AI_QUOTA_REFILL_REQUEST = gql`
  mutation UserCreateGenerativeAIQuotaRefillRequest {
    userCreateGenerativeAIQuotaRefillRequest {
      data
    }
  }
`;

export const AI_TASK_STATE = gql`
  query AiTaskState($taskId: String!) {
    aiTaskState(taskId: $taskId) {
      operationRecord {
        id
        userId
        taskId
        type
        status
        error
        updatedAt
      }
      resultMedia {
        file {
          original
          small
        }
        id
        guid
        type
        userId
        sku
        status
        productId
      }
    }
  }
`;
